<template>
  <div class="breadcrumbs-container animated--fade-in cursor-default">
    <div id="breadcrumbs" v-for="(breadcrumb, idx) in breadcrumbList" :key="idx" @click="routeTo(idx)"
      :class="{ 'linked': !!breadcrumb.link }" class="breadcrumb-item text-left fade-in">
      <div class="breadcrumb-content">
        <!-- Title Section -->
        <div class="title-section">
          <div class="title-row">
            <!-- Icon Container -->
            <div class="icon-container">
              <!-- Router Icon -->
              <i v-if="breadcrumb.icon" class="breadcrumb-icon" :class="breadcrumb.icon" />

              <!-- Props Icon -->
              <i v-else-if="icon" :class="icon" class="breadcrumb-icon" />
            </div>

            <div class="title-content">
              <h1 class="breadcrumb-title">
                <!-- Router Title -->
                <span class="title-text">
                  {{ breadcrumb.name ? breadcrumb.name : title }}
                </span>

                <!-- Props Text -->
                <span v-if="text" :style="style_title" class="title-badge" v-b-tooltip.bottom :title="text">
                  {{ text | truncate(20) }}
                </span>
              </h1>

              <!-- Subtitle Section -->
              <div class="subtitle-section">
                <span v-if="breadcrumb.subtitle || subtitle" class="breadcrumb-subtitle">
                  {{ breadcrumb.subtitle ? breadcrumb.subtitle : subtitle }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Slot -->
    <slot v-if="!configs.loading" name="action" class="animated--grow-in"></slot>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "Breadcrumbs",
  data() {
    return {
      breadcrumbList: []
    }
  },
  props: ['icon', 'text', 'style_title', 'title', 'subtitle'],
  mounted() {
    this.updateList()
  },
  watch: {
    '$route'() {
      this.updateList()
    }
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
    },
    updateList() {
      this.breadcrumbList = []
      this.$nextTick(() => {
        this.breadcrumbList = this.$route.meta.breadcrumb
      })
    }
  },
  computed: {
    ...mapState(['configs']),
    ...mapGetters([])
  }
}
</script>

<style scoped>
.breadcrumbs-container {
  /* min-height: 60px;  AQUI EH O MIN-HEIGHT PADRAO, CASO DE ERRO, USAR ESSE TAMANHO */
  min-height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 0.5rem 1.5rem;  */
  padding: 1.5rem 2.5rem 1.5rem 2.5rem !important; /* PADING PARA O CHAT */
  /* padding: 1.5rem 2.5rem 1.5rem 2.5rem !important;  PADING PARA GERAL*/
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  flex-wrap: nowrap;
  gap: 1rem;
  position: relative;
  box-sizing: border-box; 
}

.breadcrumb-wrapper {
  display: flex;
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 180px); 
  overflow: hidden;
}

.breadcrumb-item {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  max-width: 100%;
}

.breadcrumb-content {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.title-section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.title-row {
  display: flex;
  align-items: center;
  gap: 0.5rem; 
  flex-wrap: nowrap;
  width: 100%;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px; 
  width: 36px; 
  height: 36px; 
  background-color: #e8f0fe;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(66, 133, 244, 0.1);
  transition: all 0.2s ease;
}

.breadcrumb-icon {
  font-size: 1.1rem; 
  color: #4285f4;
  font-weight: 300;
  transition: all 0.2s ease;
}

.linked:hover .icon-container {
  background-color: #97bffa;
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(66, 133, 244, 0.15);
}

.linked:hover .breadcrumb-icon {
  color: #1a73e8;
}

.title-content {
  display: flex;
  flex-direction: column;
  gap: 0.2rem; 
  min-width: 0;
  flex: 1;
  overflow: hidden;
}

.breadcrumb-title {
  font-size: 1.1rem; 
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem; 
  font-weight: 600;
  line-height: 1.2;
  flex-wrap: wrap;
  max-width: 100%;
}

.title-text {
  font-size: 1.1rem; 
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.title-badge {
  font-size: 0.8rem; 
  padding: 0.2rem 0.4rem; 
  background-color: #e9ecef;
  border-radius: 1rem;
  color: #6c757d;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.subtitle-section {
  margin-top: 0.1rem; 
  width: 100%;
  overflow: hidden;
}

.breadcrumb-subtitle {
  font-size: 0.8rem; 
  color: #6c757d;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}

.linked {
  cursor: pointer;
}

.linked:hover .title-text {
  color: #4285f4;
  transition: color 0.2s ease;
}

.action-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  min-width: 80px; 
  z-index: 2;
}


.breadcrumbs-container > [name="action"] {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .breadcrumbs-container {
    padding: 0.5rem 1.25rem; 
  }
  
  .breadcrumb-wrapper {
    max-width: calc(100% - 130px);
  }
}

@media (max-width: 768px) {
  .breadcrumbs-container {
    flex-direction: column;
    align-items: flex-start;
    padding: 0.75rem 1rem; /* Reduced padding */
    gap: 1rem; /* Reduced from 1.25rem */
    min-height: auto; /* Allow height to be determined by content */
  }

  .breadcrumb-wrapper {
    max-width: 100%;
    width: 100%;
  }

  .breadcrumb-item {
    width: 100%;
  }
  
  .action-container {
    width: 100%;
    justify-content: flex-start;
    margin-top: 0.5rem;
  }

  .title-row {
    width: 100%;
  }

  .title-content {
    width: calc(100% - 45px); /* Adjusted for smaller icon */
  }

  .breadcrumb-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem; /* Reduced from 0.5rem */
  }

  .title-badge {
    align-self: flex-start;
  }
}

@media (max-width: 576px) {
  .breadcrumbs-container {
    padding: 0.5rem 0.75rem; /* Further reduced padding */
  }
  
  .icon-container {
    width: 32px; /* Further reduced */
    height: 32px; /* Further reduced */
    min-width: 32px; /* Further reduced */
  }

  .breadcrumb-icon {
    font-size: 1rem; /* Further reduced */
  }

  .title-text {
    font-size: 1rem; /* Further reduced */
  }
  
  .breadcrumb-subtitle {
    font-size: 0.75rem; /* Further reduced */
  }
  
  .title-content {
    width: calc(100% - 40px); /* Adjusted for even smaller icon */
  }
}
</style>